import type { ReactNode } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

type RuleWithMessage<V> = { value: V; message: string };

export type FormFieldControllerRulesProps = {
  required?: string;
  pattern?: RuleWithMessage<RegExp>;
  min?: RuleWithMessage<number | string>;
  max?: RuleWithMessage<number | string>;
  minLength?: RuleWithMessage<number>;
  maxLength?: RuleWithMessage<number>;
  validate?: (value: any) => string | boolean | Promise<string | boolean>;
};

export function FormFieldController({
  name,
  rules,
  children,
}: {
  name: string;
  rules?: FormFieldControllerRulesProps;
  children: ({
    field,
    fieldState,
  }: {
    field: any;
    fieldState: any;
  }) => ReactNode;
}) {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => {
        return <>{children({ field, fieldState })}</>;
      }}
    />
  );
}
